module.exports = __webpack_public_path__ + "static/img/home-news-top.1bdf9449.png";